export default __webpack_public_path__ + "static/media/mysql.203227b7.png";